import PropTypes from 'prop-types';
import FlightStops from '../FlightStops';
import TimeFlightFilters from '../TimeFlightFilters';
import AirlineFlightFilter from '../AirlineFlightFilter';
import LayoverFlightFilter from '../LayoverFlightFilter';

const FightFilters = ({ tripId }) => (
  <>
    <FlightStops
      tripId={tripId}
      isFilter
      variant="outline"
      filterSpacingClass={!tripId ? 'py-2 px-3' : undefined}
    />
    <TimeFlightFilters
      tripId={tripId}
      variant="outline"
      filterSpacingClass={!tripId ? 'py-2 px-3' : undefined}
    />
    <AirlineFlightFilter
      tripId={tripId}
      variant="outline"
      filterSpacingClass={!tripId ? 'py-2 px-3' : undefined}
    />
    <LayoverFlightFilter
      tripId={tripId}
      variant="outline"
      filterSpacingClass={!tripId ? 'py-2 px-3' : undefined}
    />
  </>
);

FightFilters.propTypes = {
  tripId: PropTypes.string,
};

FightFilters.defaultProps = {
  tripId: undefined,
};
export default FightFilters;
